import styles from './index.module.css';
import DOMPurify from 'dompurify';
const Temperature = ({ textData }) => {
  return (
    <div className={styles.ctn}>
      <div className={styles.textBox}>
        <h1
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text28']),
          }}
        ></h1>
        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text29']),
          }}
        ></h5>
      </div>

      <div className={styles.paramsBox}>
        <div>
          <div className={styles.paramsItem}>
            <h5
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text30']),
              }}
            ></h5>
            <h3
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text31']),
              }}
              className={styles.temperatureParams}
            ></h3>
          </div>
          <div className={styles.paramsItem}>
            <h5
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text32']),
              }}
            ></h5>
            <h3
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text33']),
              }}
              className="mainText"
            ></h3>
          </div>
          <div className={styles.paramsItem}>
            <h5
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text34']),
              }}
            ></h5>
            <h3
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text35']),
              }}
              className="mainText"
            ></h3>
          </div>
        </div>

        <video
         data-fade-in-play={true}
        playsInline
        muted
        preload={true}
          src="https://bucket.zhiyun-tech.com/detail/fiverayf100/f100-video-temperature.mp4"
          poster="https://bucket.zhiyun-tech.com/detail/fiverayf100/f100-video-temperature-cover.jpg"
        ></video>
      </div>

      <img
        src="https://bucket.zhiyun-tech.com/detail/fiverayf100/f100-temperature.jpg"
        alt=""
      />
    </div>
  );
};

export default Temperature;
